export default __webpack_public_path__ + "img/backbone-auth.d996ba.svg";